<template>
  <v-navigation-drawer
    :value="open"
    class="sc-navigation-drawer"
    :width="540"
    light
    right
    app
    temporary
    touchless
    @input="$emit('update:open', $event)"
  >
    <v-toolbar
      flat
      dark
      color="primary"
      class="panel-header"
    >
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <DashboardCardFiltersFields
          :value="draft"
          :source="source"
          column
          :date-label="dateLabel"
          :default-start-date="defaultStartDate"
          :default-end-date="defaultEndDate"
          :loading="loading"
          :filter-loading="filterLoading"
          @input="draft = $event"
        />
      </v-card-text>
      <v-card-actions class="sc-navigation-drawer-actions">
        <v-spacer />
        <v-btn text class="cancel" @click="close">Cancel</v-btn>
        <v-btn color="primary" data-track="report.dashboard-filters.apply" @click="apply">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { IDashboardCardFilters } from '@/bundles/Dashboard/interfaces';

import DashboardCardFiltersFields from '@/bundles/Dashboard/components/filters/DashboardCardFiltersFields.vue';

interface IDashboardCardFiltersData {
  draft: IDashboardCardFilters;
}

export default Vue.extend({
  name: 'DashboardCardFilters',

  components: { DashboardCardFiltersFields },

  props: {
    value: {
      type: Object as PropType<IDashboardCardFilters>,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    open: Boolean,
    dateLabel: {
      type: String,
      default: '',
    },
    defaultStartDate: {
      type: String,
      default: '',
    },
    defaultEndDate: {
      type: String,
      default: '',
    },
    loading: Boolean,
    filterLoading: Boolean,
  },

  data (): IDashboardCardFiltersData {
    return {
      draft: { ...this.value },
    };
  },

  watch: {
    open (isOpen: boolean) {
      // re-snapshot on every opening so closing without apply reverts the draft
      if (isOpen) {
        this.draft = { ...this.value };
      }
    },
  },

  methods: {
    close () {
      this.$emit('update:open', false);
    },
    apply () {
      this.$emit('input', this.draft);
      this.close();
    },
  },
});
</script>
